import {
    BothVisibilitySelects,
    Labels,
    AdvancedSettingsPanel
} from 'apps/studio/components/settings/fields/Base/advanced'


export const SignatureSize = {
    label: 'Signature Size',
    settingType: 'selectInput',
    property: 'style',
    choices: [
        {
            label: 'Small',
            value: -1,
        },
        {
            label: 'Medium',
            value: 0,
        },
        {
            label: 'Large',
            value: 2,
        },
    ],
}

export const AdvancedPanel = AdvancedSettingsPanel([
    SignatureSize,
    ...BothVisibilitySelects,
    ...Labels
])
